import { useQuery } from '@tanstack/react-query';

import { getAccountBeneficiaries } from '@arrived/api_v2';
import { Beneficiary } from '@arrived/models';

import { MAX_STALE_TIME, UseQueryOptions, UseQueryResult } from '../../queries.utils';
import { useGetPrimaryAccountQuery } from '../../users';
import { beneficiariesKeyFn } from '../accounts.keys';

export function useGetAccountsBeneficiaries(options?: UseQueryOptions<Beneficiary[]>): UseQueryResult<Beneficiary[]> {
  const accountState = useGetPrimaryAccountQuery();
  const { id: accountId } = accountState.data || {};

  return useQuery(beneficiariesKeyFn(accountId!), () => getAccountBeneficiaries(accountId!), {
    ...options,
    staleTime: options?.staleTime ?? MAX_STALE_TIME,
    enabled: (options?.enabled ?? true) && accountId != null,
  });
}
